/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import { getManagerByDepartment, getRepsByManager, getDepartment } from '../../../api/medRepApi';
import useCWPContext from '../context/useCWPContext';

function Filter() {
  const { auth, setFilterForm, filterForm, monthsOptions, yearOptions, searchCwp, clearCwp } =
    useContext(useCWPContext);

  const date = new Date();
  const [managerOptions, setManagerDrowndown] = useState([]);
  const [repOptions, setRepDrowndown] = useState([]);
  const [departmentOptions, setDepartMent] = useState([]);

  const loadDepartmentDropdown = async () => {
    try {
      let departmentDropdown;
      const res = await getDepartment();
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row,
          label: row,
        }));

        if (data.length === 1) {
          setFilterForm({ ...filterForm, department: dropdownValue[0] });
          departmentDropdown = dropdownValue;
        } else {
          departmentDropdown = [{ label: 'ALL', value: null }, ...dropdownValue];
        }
        setDepartMent(departmentDropdown);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadRepDropdown = async () => {
    const months = filterForm?.month.map((row) =>
      row.value !== null ? parseFloat(row.value) : '',
    );

    const year = date.getFullYear().toString();

    const request = {
      department: filterForm?.department?.label,
      manager_id: filterForm?.manager?.value,
      date_from:
        filterForm?.month.filter((item) => item.value === null).length > 0
          ? `${year}-01-01`
          : `${year}-${monthsOptions[Math.min(...months)].value}-01`,
      date_to:
        filterForm?.month.filter((item) => item.value === null).length > 0
          ? `${year}-12-31`
          : `${year}-${monthsOptions[Math.max(...months)].value}-31`,
      month: [],
      year: [],
      keyword: '',
    };
    const res = await getRepsByManager(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.rep_id,
        label: row.rep_name,
      }));
      setRepDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadManagersDropdown = async () => {
    const request = {
      department: filterForm.department.label ?? '',
      head_id: '',
      keyword: '',
    };
    const res = await getManagerByDepartment(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        // value: row.unique_id,
        // label: row.name,
        value: row.manager_id,
        label: row.manager_name,
      }));
      setManagerDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadDepartmentDropdown();
    loadRepDropdown();
    loadManagersDropdown();
  }, []);

  return (
    <Box>
      <Grid container spacing={2}>
        {(departmentOptions.length > 1 && auth.designation === 'admin') ||
        (departmentOptions.length > 1 && auth.designation === 'sub_admin') ||
        (departmentOptions.length > 1 && auth.level === 'Level 4') ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={
                filterForm.department
                  ? departmentOptions.find((row) => row.value === filterForm.department.value)
                  : null
              }
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        {auth.level === 'Level 3' || auth.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager'
              disableClearable
              fullWidth
              options={managerOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Managers (KASM/SAM)' />}
              size='small'
              value={filterForm.manager}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='kasssar'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='KASS/SAR' />}
            size='small'
            value={filterForm.kasssar}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'kasssar')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='months'
            multiple
            fullWidth
            options={monthsOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.month ?? []}
            noOptionsText='No Months'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== monthsOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                month: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Months' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchCwp}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearCwp}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
